import React from 'react'
import PropTypes from 'prop-types'
import { ProductImage } from '../ProductImage'
import moment from 'moment'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'

const MobileRechargeScheduleItem = props => (
  <div className='cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'>
    <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
      <ProductImage
        imageUrl=''
        alt={props.name}
        vendorId={props.vendorId}
        ready
      />
    </div>

    <div className='cart-product-info col'>
      <div className='cart-product-info row align-items-center h-100'>
        <div className='col-12 col-md-8'>
          <div className='row'>
            <div className='order-number col-12 mx-0 mb-1'>
              <p className='txt-font-body txt-body'>
                Resgate recorrente agendado
              </p>
            </div>
            <div className='product-infos col-12 mx-0'>
              <h2 className='txt-body-sm txt-font-body color-ui-2 '>
                {props.name}
              </h2>
            </div>
          </div>
          <div className='row card-price-item  mt-1'>
            <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              Será creditado em:
              <strong>
                {props.areaCode} {props.phoneNumber} agendado de{' '}
                {moment(props.initialScheduleDate)
                  .utc()
                  .format('DD/MM/YYYY')}{' '}
                até{' '}
                {moment(props.finalScheduleDate)
                  .utc()
                  .format('DD/MM/YYYY')}{' '}
              </strong>
            </div>

            {props.vendorName && props.vendorName !== 'Compra de Pontos' ? (
              <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                Fornecido e entregue por: <strong>{props.vendorName}</strong>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
)

MobileRechargeScheduleItem.propTypes = {
  name: PropTypes.string,
  vendorName: PropTypes.string,
  areaCode: PropTypes.number,
  phoneNumber: PropTypes.string,
  vendorId: PropTypes.number,
  initialScheduleDate: PropTypes.objectOf(typeof date),
  finalScheduleDate: PropTypes.objectOf(typeof date)
}

export default MobileRechargeScheduleItem



// WEBPACK FOOTER //
// ./src/features/ConfirmationMobileRechargeSchedule/MobileRechargeScheduleItem.js